var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ivu-result-icon ivu-result-icon-success"},[_c('Icon',{attrs:{"type":"ios-checkmark-circle"}})],1),_c('div',{staticClass:"ivu-result-title"},[_vm._v("新密码重置已完成，请重新登录 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }